var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9822 16.6864C34.6656 16.6864 41.7334 23.8233 41.7334 32.5914C41.7334 41.3595 34.6656 48.4964 25.9822 48.4964C17.2989 48.4964 10.231 41.3595 10.231 32.5914C10.231 23.8233 17.2989 16.6864 25.9822 16.6864ZM25.9822 13.4238C15.4976 13.4238 7 22.0044 7 32.5914C7 43.1784 15.4976 51.759 25.9822 51.759C36.4669 51.759 44.9645 43.1784 44.9645 32.5914C44.9645 22.0044 36.4669 13.4238 25.9822 13.4238Z",
    fill: "#9BABD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 16.688L35.8774 5.2201L31.984 0H19.9808L16.0874 5.2201L25.9824 16.688Z",
    fill: "#4A567A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2409 4.73072H16.4509L16.0874 5.2201L16.5074 5.70949H21.5721L24.8596 15.3911L25.9824 16.688L27.1052 15.3911L30.3927 5.70949H35.4574L35.8774 5.2201L35.5139 4.73072H30.7239L32.2263 0.318099L31.9921 0H31.3136L29.9323 4.07005L27.2263 0H26.0632L29.2134 4.73072H22.7837L25.9339 0H24.7708L22.0648 4.07005L20.6835 0H20.005L19.7708 0.318099L21.2732 4.73072H21.2409ZM22.5979 5.70949H29.3669L25.9824 15.6685L22.5979 5.70949Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.cb89afc06f98c635447a85dc295fc3b9.svg";
export { ForwardRef as ReactComponent };